import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BeautifyDisplayStringPipe } from 'src/app/pipes/beautify-display-string/beautify-display-string.pipe';
import { beautifyCamelCaseString } from 'src/app/common/stringUtils';

@Component({
  selector: 'app-single-tag',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './single-tag.component.html',
  styleUrl: './single-tag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleTagComponent implements OnInit {
  @Input() public tag: string;

  public showTag = false;
  public displayText: string;

  private readonly _beautifyDisplayStringPipe = new BeautifyDisplayStringPipe();

  ngOnInit(): void {
    if (!this.tag || this.tag === '') {
      this.showTag = false;
      return;
    }

    this.showTag = true;
    this.displayText = beautifyCamelCaseString(this.tag);
  }
}
